import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaProOverview';

const AccountJulaProOverviewSuspense = dynamic(
	() => import('./AccountJulaProOverview'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountJulaProOverview(props: Props) {
	return <AccountJulaProOverviewSuspense {...props} />;
}
DynamicAccountJulaProOverview.displayName = 'DynamicAccountJulaProOverview';
